import { HttpInterceptor as NgHttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CitiesService } from '../cities/services/cities.service';
import { Injectable } from '@angular/core';
import { UserInfoService } from 'src/app/shared/UserInfo/user-info.service';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptor implements NgHttpInterceptor {
  constructor(private citiesService: CitiesService, private userInfoService: UserInfoService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.userInfoService.getAuthToken();
    const userSelectedCityId = this.citiesService.getUserSelectedCityId();
   
    let clonedReq = req;
    if (token) {
      clonedReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`)
        .set('x-user-selected-city', userSelectedCityId)
      });
    }

    return next.handle(clonedReq).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const newToken = event.headers.get('next-token'); 
          if (newToken) {
            this.userInfoService.setAuthToken(newToken.replace('Bearer ', ''));
          }
        }
      })
    );
  }
}